import { useEffect } from 'react'

let audio = new Audio('/splotch.mp3')

const useSplotchAudio = () => {
    useEffect(() => {
        if (audio) {
            audio.preload = 'auto'
            audio.load()
        }
    }, [])

    const playSplotch = () => {
        const click = audio.cloneNode()
        click.play()
    }
    return playSplotch
}

export default useSplotchAudio
